import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { FeatureTagResolver } from 'src/app/shared/resolvers/feature-tag.resolver';
import { MembershipConfirmComponent } from './membership-confirm.component';
import { UserDetailsResolver } from 'src/app/shared/resolvers/user-details.service';


export const routes = [
    {
        path: "",
        component: MembershipConfirmComponent,
        resolve: { featureTags: FeatureTagResolver, userDetails: UserDetailsResolver },
    },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule
  ],
  declarations: [
    MembershipConfirmComponent
  ]
})
export class MembershipModule { }
